// UI texts: the Market (11. 10. 2026, owner; docs/marketplace.md)
export default {
  title: 'Market',
  tagline: 'Gear and Blueprints from other survivors, for Relic Shards.',
  back: 'Back to camp',
  shards: '{n} Relic Shards',
  tabs: { browse: 'Browse', sell: 'Sell', mine: 'My listings' },
  /** The menu's tooltip while it is closed. */
  lockTip: 'Opens at level {n}, once your account is {d} days old',
  locked: {
    off: 'The Market is not open yet.',
    level: 'The Market opens at level {n}.',
    age: 'The Market opens when your account is {d} days old. {t} to go.',
  },
  filters: {
    title: 'Filters',
    kind: 'Kind',
    kinds: { item: 'Gear', blueprint: 'Blueprints' },
    slot: 'Slot',
    tier: 'Tier',
    rarity: 'Rarity',
    weaponClass: 'Class',
    affix: 'Affix',
    minRoll: 'Lowest roll',
    sort: 'Sort',
    any: 'Any',
    rollAtLeast: '{n}% or more',
    sorts: { price_asc: 'Price: low to high', price_desc: 'Price: high to low', power_desc: 'Power: high to low', power_asc: 'Power: low to high', new: 'Newest' },
    clear: 'Clear',
    found: '{n} found',
  },
  buy: 'Buy',
  view: 'View',
  empty: 'Nothing here yet',
  emptyBody: 'No listing matches. Try fewer filters, or come back later.',
  by: 'by {name}',
  crew: '[{tag}]',
  left: '{t} left',
  ends: 'Ends in {t}',
  price: '{n} shards',
  priceLong: '{n} Relic Shards',
  vsWorn: 'vs worn',
  nothingWorn: 'Nothing worn there',
  yourPower: 'Your Power {pct}',
  avg7: '7-day average {n}',
  avg7none: 'No sales in 7 days',
  owners: 'Owners {n}/{max}',
  /** 11. 10. 2026 (owner): a broken item may be listed, and says so. */
  durability: 'Durability {n}/{max}',
  broken: 'Broken',
  brokenNote: 'Broken: its stats are {pct}% lower until it is repaired.',
  ownersTip: 'A Legendary changes owners at most {max} times.',
  blueprint: { pool: 'Teaches one of {n} items', zone: 'From {zone}', anyZone: 'Any item of the book' },
  detail: {
    seller: 'Seller',
    history: 'Price history',
    historyBody: 'Average price of the sales in the last {d} days.',
    historyNone: 'No sales of this kind in the last {d} days.',
    day: '{n} sold',
    buy: 'Buy for {n} shards',
    short: 'You need {n} more Relic Shards.',
    /** 13. 10. 2026 (owner): how far a purchase leaves the buyer from the next Relic Forge. */
    forgeLeft: 'This leaves you {n} Shards from your next forge.',
    forgeKept: 'You still have enough Shards for your next forge.',
    own: 'This is your listing.',
    bought: 'Bought: {name}. It is in your Storage.',
    boughtNote: 'You can list it again in {h} hours.',
    taxNote: '{pct}% of every sale is lost to the tax.',
  },
  sell: {
    intro: 'List gear and Blueprints from your Storage. You set the price, the first buyer gets it.',
    active: 'Active listings {n}/{max}',
    rules: 'A listing lasts {h} hours. The fee is paid in Scrap and not given back. {pct}% of the price is lost to the tax.',
    none: 'Nothing to list',
    noneBody: 'Gear in your Storage and your Blueprints show here.',
    list: 'List',
    full: 'You have {max} listings up.',
    range: '{floor}–{ceiling} shards',
    sheetTitle: 'List on the Market',
    priceLabel: 'Price (Relic Shards)',
    less: 'Lower the price',
    more: 'Raise the price',
    fee: 'Fee: {n} Scrap',
    feeShort: 'You need {n} Scrap for the fee.',
    youGet: 'You get {n} after the tax',
    confirm: 'List for {n} shards',
    listed: 'Listed: {name}',
    keep: {
      equipped: 'Worn',
      not_storage: 'Not in Storage',
      busy: 'In a Workshop job',
      locked: 'Locked',
      account_bound: 'Bound to you',
      taken: 'Taken in a fight: {t} left',
      bought: 'Bought: can be listed in {t}',
      owners: 'Owners {max}/{max}: it stays with you',
      arena: 'In your arena set',
    },
  },
  mine: {
    soldToday: 'Sold today {n}/{max}',
    capNote: 'After {max} sales your other listings wait until tomorrow.',
    active: 'Active',
    sold: 'Sold',
    expired: 'Expired',
    none: 'None',
    take: 'Take down',
    taken: 'Taken down. It is back in your Storage.',
    soldTo: 'Sold to {name}',
    got: 'You got {n} ({tax} tax)',
    status: { expired: 'Expired: back in Storage', canceled: 'Taken down', season: 'Season ended', reversed: 'Sale taken back' },
    feePaid: 'Fee {n} Scrap',
  },
  art: 'The Market',
};
